import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import ToolTip from '@/components/ToolTip/ToolTip';
import styles from './styles.module.scss';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';

const OP_ORDER = ['sale', 'rent', 'temporary_rent'];

export default function ValueCell({ value }) {
  const safetyValue = value ?? {};

  const texts = {
    sale: Trans(translations, 'Sale'),
    rent: Trans(translations, 'Rent'),
    temporary_rent: Trans(translations, 'TemporaryRent'),
  };

  const formatNumber = (v) =>
    typeof v === 'number' ? new Intl.NumberFormat('es-AR').format(v) : v;

  const formatAmount = (a) => `${a.currency} ${formatNumber(a.value)}`;

  const entries = OP_ORDER.map((k) => [k, safetyValue?.[k]]).filter(
    ([, amounts]) => Array.isArray(amounts) && amounts.length > 0
  );

  const hasValue = entries.length > 0;

  if (!hasValue) {
    return <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />;
  }

  const contentText = entries
    .flatMap(([, amounts]) => amounts)
    .map(formatAmount)
    .join(' / ');

  const tooltip = (
    <Box className={styles.valueCellTooltip}>
      {entries.map(([key, amounts]) => (
        <Box key={key} className={styles.valueCellTooltipRow}>
          <Text
            variant="body.fontSize13"
            className={styles.valueCellTooltipLabel}
          >
            {texts[key] ?? key}
          </Text>

          <Box className={styles.valueCellTooltipAmounts}>
            {amounts.map((amount, index) => (
              <Text
                // eslint-disable-next-line
                key={`${key}-${amount.currency}-${index}`}
                variant="body.fontSize13"
                className={styles.valueCellTooltipAmount}
              >
                {formatAmount(amount)}
              </Text>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );

  const content = (
    <Box variant="body.fontSize13" className={styles.valueCellContent}>
      {contentText}
    </Box>
  );

  return <ToolTip title={tooltip}>{content}</ToolTip>;
}
